import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";
import {
  getPurchasableFromPurchasableMap,
  getPurchasableImage,
  getVariantImageFromPurchasableMap,
} from "@smartrr/shared/utils/useVariantToPurchasableMap";
import { useMemo } from "react";

import { useCustomerPortalVariantToPurchasableMap } from "@customer-app/state/reducers/purchasables";

import { sortAndFilterLineItemsForDisplay } from "../../../utils";

export const useBackgroundImageFromLineItems = (delivery: PurchaseStateAndDelivery) => {
  const { indexFromScheduleStart: skdIdx, purchaseState } = delivery;
  const { stLineItems: lineItems } = purchaseState;

  const variantToPurchasableMap = useCustomerPortalVariantToPurchasableMap();

  /** while line items *should* be already sorted by date, there are cases where the newest item in the array is the first element. */
  const sortedLineItems = sortAndFilterLineItemsForDisplay(purchaseState, skdIdx, true);

  return useMemo(() => {
    let image: string | undefined;

    for (const lineItem of sortedLineItems) {
      const purchasable = getPurchasableFromPurchasableMap(variantToPurchasableMap, lineItem.vnt);

      if (image) {
        break;
      }

      image =
        getVariantImageFromPurchasableMap(variantToPurchasableMap, lineItem.vnt) ??
        getPurchasableImage(purchasable);
    }

    // In cases where no image is present in either the purchasable or it's variants, set to empty string and
    // add condition within styling
    if (!image) {
      image = "";
    }
    return image;
  }, [lineItems, variantToPurchasableMap]);
};
